module.exports = __webpack_public_path__ + "img/scissors.8fcd79a6.svg";